"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[264],{

/***/ 84970:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ logEvent; },
/* harmony export */   "g": function() { return /* binding */ searchEvents; }
/* harmony export */ });
/* harmony import */ var _opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64687);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63144);





function logEvent(_x, _x2, _x3, _x4, _x5, _x6) {
  return _logEvent.apply(this, arguments);
}

function _logEvent() {
  _logEvent = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee(productVersionId, email, action, source, eventName, props) {
    var nextConfig, apiOptions, apiResponse, log;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            apiOptions = {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              mode: 'same-origin',
              method: 'post',
              body: JSON.stringify({
                userEmail: email,
                source: source,
                action: action,
                eventName: eventName,
                props: props
              })
            };
            _context.next = 4;
            return unfetch__WEBPACK_IMPORTED_MODULE_2__("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(productVersionId, "/eventWrite"), apiOptions);

          case 4:
            apiResponse = _context.sent;

            if (!apiResponse.ok) {
              _context.next = 12;
              break;
            }

            _context.next = 8;
            return apiResponse.text();

          case 8:
            log = _context.sent;
            console.log(log);
            _context.next = 13;
            break;

          case 12:
            console.log('error during logging');

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _logEvent.apply(this, arguments);
}

function searchEvents(_x7) {
  return _searchEvents.apply(this, arguments);
}

function _searchEvents() {
  _searchEvents = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee2(productVersionId) {
    var nextConfig, apiResponse, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context2.next = 3;
            return unfetch__WEBPACK_IMPORTED_MODULE_2__("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(productVersionId, "/eventsRead?source=mcc-manager"));

          case 3:
            apiResponse = _context2.sent;

            if (!apiResponse.ok) {
              _context2.next = 11;
              break;
            }

            _context2.next = 7;
            return apiResponse.json();

          case 7:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 11:
            if (!(apiResponse.status === 404)) {
              _context2.next = 16;
              break;
            }

            console.log('api responded with zero results');
            return _context2.abrupt("return", []);

          case 16:
            console.error('api response not ok');

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _searchEvents.apply(this, arguments);
}



/***/ }),

/***/ 44264:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ importVariables; },
/* harmony export */   "EP": function() { return /* binding */ deleteProductVersion; },
/* harmony export */   "FI": function() { return /* binding */ reindexProducts; },
/* harmony export */   "Is": function() { return /* binding */ getUsersByGroup; },
/* harmony export */   "O5": function() { return /* binding */ createProductVersion; },
/* harmony export */   "O8": function() { return /* binding */ batchRegisterDoi; },
/* harmony export */   "P6": function() { return /* binding */ readVocabList; },
/* harmony export */   "Qc": function() { return /* binding */ updateProductVersion; },
/* harmony export */   "Sv": function() { return /* binding */ downloadFile; },
/* harmony export */   "XY": function() { return /* binding */ getProductByProductVersionId; },
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "cT": function() { return /* binding */ uploadFile; },
/* harmony export */   "gl": function() { return /* binding */ getProductsByProductIdAndProductType; },
/* harmony export */   "is": function() { return /* binding */ addPublishedDate; },
/* harmony export */   "ji": function() { return /* binding */ reindexProductByProductId; },
/* harmony export */   "m1": function() { return /* binding */ readProductVersion; },
/* harmony export */   "mN": function() { return /* binding */ registerDoi; },
/* harmony export */   "oG": function() { return /* binding */ addPublishedDates; },
/* harmony export */   "u1": function() { return /* binding */ createNewVersion; },
/* harmony export */   "xT": function() { return /* binding */ reindexProduct; },
/* harmony export */   "yU": function() { return /* binding */ retrieveCitation; },
/* harmony export */   "zF": function() { return /* binding */ changeWorkflowActions; }
/* harmony export */ });
/* unused harmony exports readVocabularies, getRelationships */
/* harmony import */ var _opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64687);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var form_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6230);
/* harmony import */ var _EventLogger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84970);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74865);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9229);
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63144);










function readProductVersion(_x, _x2) {
  return _readProductVersion.apply(this, arguments);
}

function _readProductVersion() {
  _readProductVersion = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee(productVersionId, loadVocab) {
    var nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (productVersionId) {
              _context.next = 3;
              break;
            }

            console.log('Cannot readProductVersion if no productVersionId provided.');
            return _context.abrupt("return");

          case 3:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context.next = 6;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/product/").concat(productVersionId, "?loadVocab=").concat(loadVocab));

          case 6:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readProductVersion.apply(this, arguments);
}

function retrieveCitation(_x3) {
  return _retrieveCitation.apply(this, arguments);
}

function _retrieveCitation() {
  _retrieveCitation = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee2(productVersionId) {
    var nextConfig, cslName, url, apiResponse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (productVersionId) {
              _context2.next = 3;
              break;
            }

            console.log('Cannot retrieveCitation if no productVersionId provided.');
            return _context2.abrupt("return", null);

          case 3:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            cslName = 'chicago-note-bibliography-16th-edition';
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(productVersionId, "/citation?cslName=").concat(cslName);
            nprogress__WEBPACK_IMPORTED_MODULE_5__.start();
            _context2.next = 9;
            return unfetch__WEBPACK_IMPORTED_MODULE_7__(url, apiOptions('post', null));

          case 9:
            apiResponse = _context2.sent;

            if (!apiResponse.ok) {
              _context2.next = 17;
              break;
            }

            // console.log('api responded ok');
            nprogress__WEBPACK_IMPORTED_MODULE_5__.done();
            _context2.next = 14;
            return apiResponse.text();

          case 14:
            return _context2.abrupt("return", _context2.sent);

          case 17:
            nprogress__WEBPACK_IMPORTED_MODULE_5__.done();
            console.error('api response not ok');

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _retrieveCitation.apply(this, arguments);
}

function readVocabularies(_x4, _x5) {
  return _readVocabularies.apply(this, arguments);
}

function _readVocabularies() {
  _readVocabularies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value, apiPath) {
    var nextConfig, url, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log('Executing readVocabularies for value = ' + value + ' and apiPath = ' + apiPath + '.');
            nextConfig = getConfig();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath).concat(apiPath.replace('/api/v1', ''));

            if (value != '') {
              url += "?q=".concat(value);
            } //console.log(url)


            _context3.next = 6;
            return fetcher(url);

          case 6:
            data = _context3.sent;

            if (!data) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", data.map(function (term) {
              if (apiPath.includes('milestoneType')) {
                return term;
              }

              return term.label;
            }));

          case 11:
            return _context3.abrupt("return", []);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _readVocabularies.apply(this, arguments);
}

function readVocabList(_x6, _x7, _x8, _x9) {
  return _readVocabList.apply(this, arguments);
}

function _readVocabList() {
  _readVocabList = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee4(value, vocab, vocabularies, specialCase) {
    var vocabTerm, nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            vocabTerm = vocab.substring(vocab.lastIndexOf('/') + 1);

            if (specialCase) {
              _context4.next = 4;
              break;
            }

            if (!(vocabularies && Object.keys(vocabularies).length > 0 && vocabularies[vocabTerm])) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", vocabularies[vocabTerm]);

          case 4:
            if (!vocab.startsWith('/')) {
              vocab = '/' + vocab;
            }

            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath).concat(vocab.replace('/api/v1', ''));

            if (value != '') {
              url += "?q=".concat(value);
            }

            _context4.next = 10;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url);

          case 10:
            data = _context4.sent;

            if (!data) {
              _context4.next = 15;
              break;
            }

            return _context4.abrupt("return", data);

          case 15:
            return _context4.abrupt("return", []);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _readVocabList.apply(this, arguments);
}

function getRelationships(_x10, _x11) {
  return _getRelationships.apply(this, arguments);
}

function _getRelationships() {
  _getRelationships = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(value, ontology) {
    var nextConfig, url, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            nextConfig = getConfig();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/relationships/types/").concat(ontology);

            if (value != '') {
              url += "?q=".concat(value);
            }

            _context5.next = 5;
            return fetcher(url);

          case 5:
            data = _context5.sent;
            return _context5.abrupt("return", data ? data : []);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getRelationships.apply(this, arguments);
}

function getProductByProductVersionId(_x12) {
  return _getProductByProductVersionId.apply(this, arguments);
}

function _getProductByProductVersionId() {
  _getProductByProductVersionId = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee6(productVersionId) {
    var nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context6.next = 3;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/product/").concat(productVersionId));

          case 3:
            data = _context6.sent;
            return _context6.abrupt("return", data ? data : []);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getProductByProductVersionId.apply(this, arguments);
}

function getProductsByProductIdAndProductType(_x13, _x14) {
  return _getProductsByProductIdAndProductType.apply(this, arguments);
}

function _getProductsByProductIdAndProductType() {
  _getProductsByProductIdAndProductType = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee7(productId, productType) {
    var nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context7.next = 3;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin?productType=").concat(productType, "&productId=").concat(productId));

          case 3:
            data = _context7.sent;
            return _context7.abrupt("return", data ? data : []);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getProductsByProductIdAndProductType.apply(this, arguments);
}

function createProductVersion(_x15, _x16, _x17, _x18, _x19, _x20) {
  return _createProductVersion.apply(this, arguments);
}

function _createProductVersion() {
  _createProductVersion = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee8(productType, program, study, knowledgeProductType, roundType, email) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = nextConfig.publicRuntimeConfig.apiProxyBasePath + '/products/admin/product?';
            url += 'productType=' + productType;
            url += '&owner=' + email;

            if (program && program !== null) {
              url += '&program=' + program;
            }

            if (study && study !== null) {
              url += '&study=' + study;
            }

            if (knowledgeProductType && knowledgeProductType !== null) {
              url += '&knowledgeProductType=' + knowledgeProductType;
            }

            if (roundType && roundType !== null) {
              url += '&roundType=' + roundType;
            }

            _context8.next = 10;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 10:
            data = _context8.sent;
            return _context8.abrupt("return", data);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _createProductVersion.apply(this, arguments);
}

function deleteProductVersion(_x21, _x22) {
  return _deleteProductVersion.apply(this, arguments);
}

function _deleteProductVersion() {
  _deleteProductVersion = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee9(productVersionId, sourcePath) {
    var nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            console.log('Executing deleteProductVersion for productVersionId = ' + productVersionId + '.');
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context9.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(productVersionId), apiOptions('delete'));

          case 4:
            data = _context9.sent;
            if (data) next_router__WEBPACK_IMPORTED_MODULE_2__.reload();

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _deleteProductVersion.apply(this, arguments);
}

function createNewVersion(_x23, _x24, _x25) {
  return _createNewVersion.apply(this, arguments);
}

function _createNewVersion() {
  _createNewVersion = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee10(productVersionId, type, sourcePath) {
    var nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            console.log('Executing createNewVersion for productVersionId = ' + productVersionId + '.');

            if (!(type == 'update' || type == 'patch')) {
              _context10.next = 9;
              break;
            }

            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context10.next = 5;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(productVersionId, "/createNewVersion?type=").concat(type), apiOptions('post', null));

          case 5:
            data = _context10.sent;
            return _context10.abrupt("return", data);

          case 9:
            return _context10.abrupt("return", 'Update type not valid.');

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _createNewVersion.apply(this, arguments);
}

function updateProductVersion(_x26) {
  return _updateProductVersion.apply(this, arguments);
}

function _updateProductVersion() {
  _updateProductVersion = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee11(product) {
    var nextConfig, apiResponse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            console.log('Executing updateProductVersion for productVersionId = ' + product.productVersionId + '.');
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context11.next = 4;
            return unfetch__WEBPACK_IMPORTED_MODULE_7__("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/admin/product/").concat(product.productVersionId), apiOptions('put', JSON.stringify(product)));

          case 4:
            apiResponse = _context11.sent;
            return _context11.abrupt("return", apiResponse);

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _updateProductVersion.apply(this, arguments);
}

function uploadFile(_x27, _x28, _x29, _x30) {
  return _uploadFile.apply(this, arguments);
}

function _uploadFile() {
  _uploadFile = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee12(file, productVersionId, properties, email) {
    var formData, apiOptions, nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            formData = new form_data__WEBPACK_IMPORTED_MODULE_3__();
            formData.append('file', file);
            formData.append('productVersionId', productVersionId);
            formData.append('properties', properties);
            apiOptions = {
              mode: 'same-origin',
              method: 'post',
              body: formData
            };
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context12.next = 8;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/").concat(productVersionId, "/files/upload"), apiOptions);

          case 8:
            data = _context12.sent;
            return _context12.abrupt("return", data);

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _uploadFile.apply(this, arguments);
}

function downloadFile(_x31, _x32, _x33, _x34, _x35, _x36) {
  return _downloadFile.apply(this, arguments);
}

function _downloadFile() {
  _downloadFile = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee13(fileId, fileName, productVersionId, properties, email, productId) {
    var nextConfig, url, propertiesMap, val, disclosure, sensitive, err, _err, res, _err2, props, blob, objUrl, link;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/").concat(productVersionId, "/files/").concat(fileId, "/download");
            propertiesMap = {};

            for (val in properties) {
              propertiesMap[properties[val].field] = properties[val].value;
            }

            disclosure = propertiesMap.disclosure, sensitive = propertiesMap.sensitive;

            if (!(disclosure === 'true')) {
              _context13.next = 8;
              break;
            }

            err = "You can't download this file because it contains identifiable information.";
            return _context13.abrupt("return", err);

          case 8:
            if (!(sensitive === 'true')) {
              _context13.next = 11;
              break;
            }

            _err = "You can't download this file because it contains sensitive information.";
            return _context13.abrupt("return", _err);

          case 11:
            _context13.next = 13;
            return unfetch__WEBPACK_IMPORTED_MODULE_7__(url);

          case 13:
            res = _context13.sent;

            if (res.ok) {
              _context13.next = 19;
              break;
            }

            _context13.next = 17;
            return res.text();

          case 17:
            _err2 = _context13.sent;
            return _context13.abrupt("return", _err2);

          case 19:
            props = {};
            props['FILE_ID'] = fileId;
            props['FILE_NAME'] = fileName;
            props['PRODUCT_ID'] = productId;
            (0,_EventLogger__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .K)(productVersionId, email, "downloaded file; " + fileName, 'mcc-manager', 'DOWNLOAD_FILE', props);
            _context13.next = 26;
            return res.blob();

          case 26:
            blob = _context13.sent;
            objUrl = window.URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = objUrl;
            link.download = fileName;
            link.click(); // For Firefox it is necessary to delay revoking the ObjectURL.

            setTimeout(function () {
              window.URL.revokeObjectURL(objUrl);
            }, 250);

          case 33:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _downloadFile.apply(this, arguments);
}

function changeWorkflowActions(_x37, _x38, _x39, _x40, _x41, _x42) {
  return _changeWorkflowActions.apply(this, arguments);
}

function _changeWorkflowActions() {
  _changeWorkflowActions = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee14(productVersionId, workflowId, statusTransitionId, email, notes, statusTransition) {
    var formData, apiOptions, nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            formData = new form_data__WEBPACK_IMPORTED_MODULE_3__();
            formData.append('data', notes);
            formData.append('email', email);
            formData.append('transitionAction', statusTransition); //console.log(statusTransition)

            apiOptions = {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'same-origin',
              method: 'post',
              body: JSON.stringify(statusTransition)
            };
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context14.next = 8;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products/").concat(productVersionId, "/workflows/").concat(workflowId, "/transitions/").concat(statusTransitionId, "?notes=").concat(notes, "&email=").concat(email), apiOptions);

          case 8:
            data = _context14.sent;
            return _context14.abrupt("return", data);

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _changeWorkflowActions.apply(this, arguments);
}

function getUsersByGroup(_x43) {
  return _getUsersByGroup.apply(this, arguments);
}

function _getUsersByGroup() {
  _getUsersByGroup = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee15(groupLabel) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/radius/users?groupLabel=") + groupLabel;
            _context15.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url);

          case 4:
            data = _context15.sent;
            return _context15.abrupt("return", data ? data[0] : null);

          case 6:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _getUsersByGroup.apply(this, arguments);
}

function importVariables(_x44, _x45, _x46, _x47) {
  return _importVariables.apply(this, arguments);
}

function _importVariables() {
  _importVariables = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee16(file, schemaVersionId, email, sourcePath) {
    var formData, apiOptions, nextConfig, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            formData = new form_data__WEBPACK_IMPORTED_MODULE_3__();
            formData.append('file', file);
            formData.append('schemaVersionId', schemaVersionId);
            formData.append('email', email);
            apiOptions = {
              mode: 'same-origin',
              method: 'post',
              body: formData
            };
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            _context16.next = 8;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/importVariables"), apiOptions);

          case 8:
            data = _context16.sent;

            if (data) {
              next_router__WEBPACK_IMPORTED_MODULE_2__.reload();
            }

          case 10:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _importVariables.apply(this, arguments);
}

function getProducts(_x48) {
  return _getProducts.apply(this, arguments);
}

function _getProducts() {
  _getProducts = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee17(queryString) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/products");

            if (queryString && queryString !== null) {
              url += '?' + queryString;
            }

            _context17.next = 5;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url);

          case 5:
            data = _context17.sent;
            return _context17.abrupt("return", data ? data : []);

          case 7:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _getProducts.apply(this, arguments);
}

function reindexProducts() {
  return _reindexProducts.apply(this, arguments);
}

function _reindexProducts() {
  _reindexProducts = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee18() {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/reindex");
            _context18.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context18.sent;
            return _context18.abrupt("return", data);

          case 6:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _reindexProducts.apply(this, arguments);
}

function addPublishedDates() {
  return _addPublishedDates.apply(this, arguments);
}

function _addPublishedDates() {
  _addPublishedDates = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee19() {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/add-published-dates");
            _context19.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context19.sent;
            return _context19.abrupt("return", data);

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _addPublishedDates.apply(this, arguments);
}

function addPublishedDate(_x49) {
  return _addPublishedDate.apply(this, arguments);
}

function _addPublishedDate() {
  _addPublishedDate = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee20(productVersionId) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/").concat(productVersionId, "/add-published-date");
            _context20.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context20.sent;
            return _context20.abrupt("return", data);

          case 6:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _addPublishedDate.apply(this, arguments);
}

function reindexProduct(_x50) {
  return _reindexProduct.apply(this, arguments);
}

function _reindexProduct() {
  _reindexProduct = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee21(productVersionId) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/").concat(productVersionId, "/reindex");
            _context21.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context21.sent;
            return _context21.abrupt("return", data);

          case 6:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _reindexProduct.apply(this, arguments);
}

function registerDoi(_x51) {
  return _registerDoi.apply(this, arguments);
}

function _registerDoi() {
  _registerDoi = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee22(productVersionId) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/").concat(productVersionId, "/register-doi");
            _context22.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context22.sent;
            return _context22.abrupt("return", data);

          case 6:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _registerDoi.apply(this, arguments);
}

function batchRegisterDoi() {
  return _batchRegisterDoi.apply(this, arguments);
}

function _batchRegisterDoi() {
  _batchRegisterDoi = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee23() {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/dois/register-doi");
            _context23.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context23.sent;
            return _context23.abrupt("return", data);

          case 6:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _batchRegisterDoi.apply(this, arguments);
}

function reindexProductByProductId(_x52, _x53) {
  return _reindexProductByProductId.apply(this, arguments);
}

function _reindexProductByProductId() {
  _reindexProductByProductId = (0,_opt_app_root_src_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.mark(function _callee24(productId, productType) {
    var nextConfig, url, data;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            nextConfig = next_config__WEBPACK_IMPORTED_MODULE_1__();
            url = "".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/admin/products/").concat(productId, "/type/").concat(productType, "/reindex");
            _context24.next = 4;
            return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .fetcher */ ._i)(url, apiOptions('post'));

          case 4:
            data = _context24.sent;
            return _context24.abrupt("return", data);

          case 6:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _reindexProductByProductId.apply(this, arguments);
}

function apiOptions(method, body) {
  return {
    mode: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    method: method,
    body: body
  };
}



/***/ })

}]);